/* eslint-disable no-lone-blocks */
/* eslint-disable no-console */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-undef */
/* eslint-disable max-len */
import React, { useContext, useRef, useState } from 'react';
import { Grid, CircularProgress } from '@mui/material';
import { LanguageContext } from '../../../../../../../../libs/Context';
import { useSelector } from 'react-redux';
import { getBreadCrumbs } from '../../../../../../../actions/media_actions';
import { catchErr, configureStore, generateThumbnailFromVideo, getBlobUrl, getDataUrlFrmLocalSystm, handleThumbnail, objectUrlToFile, s3DeleteNew } from '../../../../../../../../libs/HelperContent';
import NoData from '../../../../../../../../components/Common/NoData';
import { Storage } from 'aws-amplify';
import { toast } from 'react-toastify';
import Loading from '../../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { renderComp } from './MediaData';
import { createFeedContext } from '../../../CreationPopup';
import { acceptedDocs, acceptedImages, acceptedVideos } from '../Common';
import MediaDriveBreadCrumbs from './BreadCrumbs';

interface Thumbnail {
    thumbnailFile: any;
    width: any;
    height: any;
}

const MediaDriveUpload = (props) =>
{
	const { uploadedFiles, setUploadedFiles, footerActn } = props;
	const userData = useSelector((state:any) => state.mysession.session);
	const { language } = useContext(LanguageContext);
	const [ page, setPage ] = useState<any>(0);
	const [ loading, setLoading ] = useState<any>(false);
	const [ count, setCount ] = useState<any>(0);
	const [ breadCrumbs, setBreadCrumbs ] = useState<any>([]);
	const [ foldersData, setFoldersData ] = useState<any>([]);
	const folderId = useRef<any>('');
	const loaderRef = useRef<any>();
	const { createFeed } = useContext(createFeedContext);
	const customPrefix:any = { public: `${userData?.companyId}/feed/` };

	// Size limits for different file types (only for documents)
	const FILE_SIZE_LIMITS = {
		// video       : 500 * 1024 * 1024, // 500MB for videos
		// image       : 250 * 1024 * 1024, // 250MB for images
		application : 250 * 1024 * 1024 // 250MB for applications
	};

	// const MAX_VIDEO_DURATION = 15; // 15 minutes for video duration

	// Function to generate thumbnail for document files
	const uploadDocumnts = async (folderD, thumbnailD) =>
	{
		const imagePath = folderD?.media?.type?.split('/')[0] === 'application' ? `/documents/${folderD?.media?.name?.split('.')?.pop()}.png` : '/documents/txt.png';

		const generateBlobDoc:any = await getDataUrlFrmLocalSystm(imagePath);
		const getThumbnailfile = await objectUrlToFile(generateBlobDoc, folderD?.media?.name);

		thumbnailD.thumbnailUrl =	await configureStore(getThumbnailfile, customPrefix);
	};

	// Function to generate thumbnail for video files
	const uploadImages = async (generateFile, thumbnailD, folderD) =>
	{
		try
		{
			if (generateFile.type.startsWith('image/'))
			{
				thumbnailD.thumbnailUrl = await handleThumbnail(generateFile, customPrefix);
			}
			else
			{
				const imgFile = new File([ generateFile ], folderD?.media?.name, { type: 'image/jpeg' });

				thumbnailD.thumbnailUrl = await handleThumbnail(imgFile, customPrefix);
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	// Function to upload file to AWS S3
	const uploadToS3 = async (folderD, thumbnailD) =>
	{
		await Storage.configure({
			bucket       : process.env.REACT_APP_S3_BUCKET,
			region       : process.env.REACT_APP_S3_BUCKET_REGION,
			customPrefix : {
				public : ''
			}
		});

		const key = folderD?.media?.key;
		const destinationKey = key.split('/')[1];
		const replaceKeyname = key.replace(destinationKey, 'feed');

		const lastIndex = replaceKeyname.lastIndexOf('/');

		const newKey = `${replaceKeyname.substring(0, lastIndex)}/${new Date().valueOf()}${folderD?.media?.name}`;

		const isVideo = folderD?.media?.type?.split('/')[0] === 'video';

		if (newKey && key)
		{
			const copiedObj:any = await Storage.copy({ key }, { key: newKey });

			const newObj = {
				url       : `${process.env.REACT_APP_S3_BASE_URL}/${copiedObj?.key}`,
				type      : folderD?.media?.type,
				key       : copiedObj?.key,
				title     : copiedObj?.key.split('/').pop(),
				name      : folderD?.media?.name,
				size      : folderD?.media?.size,
				thumbnail : thumbnailD.thumbnailUrl,
				...(isVideo && { height: thumbnailD?.thumbnailWdth }),
				...(isVideo && { width: thumbnailD?.thumbailHght }),
				tab       : 0
			};

			setUploadedFiles((prev) => [ ...prev, newObj ]);
			setLoading(false);
		}
	};

	// Function to process file upload from cloud storage
	const processFileUpload = async (folderD, filterFiles, limitSlctn) =>
	{
		if (limitSlctn || (filterFiles && Object.keys(filterFiles)?.length > 0))
		{
			if (filterFiles)
			{
				const filterItems = uploadedFiles?.filter(
					(slctd) => slctd?.name !== folderD?.media?.name && slctd?.size !== folderD?.media?.size
				);

				setUploadedFiles(filterItems);
				await s3DeleteNew(filterFiles?.key, '');
			}
			else
			{
				setLoading(true);
				const thumbnailD:any = {};
				const checkSlctdFile = folderD?.media?.type?.split('/')[0];
				let generateBlob:any, generateFile:any;

				if (![ 'application', 'text' ].includes(folderD?.media?.type?.split('/')[0]))
				{
					generateBlob = await getBlobUrl(folderD?.media?.key);
					generateFile = await objectUrlToFile(generateBlob, folderD?.name);
				}

				if ([ 'application', 'text' ].includes(folderD?.media?.type?.split('/')[0]))
				{
					await uploadDocumnts(folderD, thumbnailD);
				}

				if (checkSlctdFile === 'video')
				{
					const { thumbnailFile, width, height } = await generateThumbnailFromVideo(generateFile) as Thumbnail;

					thumbnailD.thumbnailUrl = await configureStore(thumbnailFile, customPrefix);
					thumbnailD.thumbnailWdth = width;
					thumbnailD.thumbailHght = height;
				}

				if (folderD?.media?.type?.startsWith('image/'))
				{
					await uploadImages(generateFile, thumbnailD, folderD);
				}

				await uploadToS3(folderD, thumbnailD);
				setLoading(false);
			}
		}
		else
		{
			// Set maxFiles based on footerActn: 5 for documents, 20 for images/videos
			const maxFiles = footerActn === 'application' ? 5 : 20;

			toast.error(`Cannot upload more than ${maxFiles} files.`, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	// Function to handle selected files
	const handleSlctdFiles = async (folderD) =>
	{
		const checkSlctdFile = folderD?.media?.type?.split('/')[0];

		if (folderD?.media && [ 'image', 'video', 'application' ].includes(checkSlctdFile))
		{
			const filterFiles = uploadedFiles?.find(
				(slctd) => slctd?.name === folderD?.media?.name && slctd?.size === folderD?.media?.size
			);

			const exceptLinksMedia = (createFeed?.media ?? [])?.filter((each) => each?.type !== 'link');

			// Set maxFiles based on footerActn: 5 for documents, 20 for images/videos
			const maxFiles = footerActn === 'application' ? 5 : 20;

			// Filter existing media by type based on footerActn
			const getExistingFilesByType = () =>
			{
				if (footerActn === 'application')
				{
					return exceptLinksMedia.filter((item) => item.type?.startsWith('application/'));
				}
				else if (footerActn === 'image_video' || footerActn === 'image' || footerActn === 'video')
				{
					return exceptLinksMedia.filter((item) =>
						item.type?.startsWith('image/') || item.type?.startsWith('video/')
					);
				}

				return exceptLinksMedia;
			};
			const existingFilesByType = getExistingFilesByType();

			// Filter uploadedFiles by type (only count files of the same type from both System and MediaDrive)
			const getUploadedFilesByType = () =>
			{
				if (footerActn === 'application')
				{
					return uploadedFiles.filter((item) => item.type?.startsWith('application/'));
				}
				else if (footerActn === 'image_video' || footerActn === 'image' || footerActn === 'video')
				{
					return uploadedFiles.filter((item) =>
						item.type?.startsWith('image/') || item.type?.startsWith('video/')
					);
				}

				return uploadedFiles;
			};
			const uploadedFilesByType = getUploadedFilesByType();

			// Count only files of the same type (documents OR images/videos)
			const limitSlctn = existingFilesByType?.length + uploadedFilesByType?.length + 1 <= maxFiles;

			// Document Validation: Check File Size (only for documents)
			if (checkSlctdFile === 'application' && folderD?.media?.size > FILE_SIZE_LIMITS.application)
			{
				toast.error('Document file size cannot exceed 250MB', {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});

				return;
			}

			// Proceed with upload (no size/duration restrictions for images/videos)
			processFileUpload(folderD, filterFiles, limitSlctn);
		}
		else
		{
			toast.error('File type not supported', {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	const handleLoadMore = () =>
	{
		if (loaderRef?.current === false)
		{
			loaderRef.current = true;
			setPage((prevState) => prevState + 1);
		}
	};

	const getBreadCrumbsData = async (id) =>
	{
		const query: any = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role,
			limit   : 12,
			skip    : page
		};

		setLoading(true);
		try
		{
			if (id) query.id = id;
			const res = await getBreadCrumbs(query);

			if (res?.status)
			{
				setBreadCrumbs(res?.data);
				setLoading(false);
			}
		}
		catch (err)
		{
			catchErr(err);
			setLoading(false);
		}
	};
	const handleFolder = (folderD) =>
	{
		const id = folderD?.folderId || folderD?.id;

		if (id)
		{
			getBreadCrumbsData(id);
		}
		setPage(0);
		folderId.current = id;
	};

	return (
		<>
			<div className='pdngHLG mrgnTSM'>
				{loading && <Loading/>}
				<MediaDriveBreadCrumbs page={page} footerActn={footerActn} folderId={folderId} setCount={setCount}
					setLoading={setLoading}
					foldersData={foldersData} setFoldersData={setFoldersData} loaderRef={loaderRef}
					breadCrumbs={breadCrumbs} handleFolder={handleFolder}
					setBreadCrumbs={setBreadCrumbs}
				/>
			</div>
			<Grid container py='var(--pixel8)' sx={{ position: 'relative' }}>
				{
					foldersData?.length > 0
						? foldersData?.map((folderD) =>
						{
							const fileType:any = folderD?.media && folderD?.media?.type && folderD?.media?.type?.split('/')[0];

							return (
								<button tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && (folderD?.type === 0 ? handleFolder(folderD) : handleSlctdFiles(folderD)); }}
									className='socialfileWidth brdrRadiusXSM pdngXS positionRelative'
									key={folderD?.folderId}
									onClick={() => (folderD?.type === 0 ? handleFolder(folderD) : handleSlctdFiles(folderD))}
								>
									{renderComp(fileType, folderD, uploadedFiles, handleFolder)}
								</button>
							);
						})
						: !loading && foldersData?.length === 0 &&
							<div className='flexCol pdngXS justifyCntr'>
								<NoData noDataHead={language?.nodataFound} color='lightTxt' src1='/images/Bpsnodata.svg' />
							</div>

				}
				{loaderRef.current
					? <div className='flexRow justifyCntr'>
						<CircularProgress />
					</div>
					: ((page + 1) * 12) < count &&
					<div className='flexRow alignCntr justifyCntr pdngXS'>
						<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleLoadMore(); }} onClick={handleLoadMore} className='loadbtn pointer alignCntr justifyCntr flexInline' >{language?.load}</button>
					</div>}
			</Grid>
		</>
	);
};

export default MediaDriveUpload;
